module.exports = __webpack_public_path__ + "static/img/jin.65803d70.png";